<script lang="ts">
  import { searchParams, updateSearchFilter } from "state/page";

  function onChange(this: HTMLInputElement) {
    if (this.checked)
    updateSearchFilter("owner", "current-user");
    else {
      updateSearchFilter("owner", undefined);
    }
  }
</script>

<label>
  <input
    type="checkbox"
    class="org-input"
    checked={$searchParams.owner === "current-user"}
    on:change={onChange}
    data-testid="mine-opplastinger"
  />
  <span>Mine opplastinger</span>
</label>

<style>
  /** Alignment is off with default values, but shouldn't need this much tweaking */
  label {
    display: flex;
    gap: var(--org-xsmall);
    align-items: center;
  }

</style>
